import { ENDPOINT } from 'api/endPoints/getActivityCompletionPlan';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemWithCustomProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { EXTRA_LARGE, LARGE } from 'components/Dashboards/Reporting/reportingConfig';

export const activityPredecessors: IHashmapItemWithCustomProps<unknown> = {
    NoPermissionMessage,
    componentKey: 'activityPredecessors',
    id: 'activity-predecessors',
    title: 'Activity Completion Plan',
    globalFiltersConfig: [{ key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null }],
    reportStyle: {
        widgetSizesAvailable: {
            large: LARGE,
            extraLarge: EXTRA_LARGE,
        },
        widgetInitialSize: LARGE,
    },
    reportConfig: {
        buttons: {
            narrative: false,
        },
        threeDotMenuOptions: {
            useAutomatedNarrative: true,
        },
        hideNarrativeEditor: true,
    },
    endpoint: ENDPOINT,
};
